import useMap from "../../components/useMap";
import useSelectedFeatures from "../../components/maps/GeoJSONMap/useSelectedFeatures";
import {useGeoJSONModel23Stations} from "../../components/maps/query";


const useModels23Map = ({models23Filters}) => {
    const geoStationQuery = useGeoJSONModel23Stations(models23Filters);
    const stationGeoJSON = geoStationQuery.data ?? {type: "FeatureCollection", features: []};
    const map = useMap();
    const selectedFeatures = useSelectedFeatures({features: stationGeoJSON.features});

    return {
        geoJSON: stationGeoJSON,
        ...map,
        ...selectedFeatures,
    }
}


export default useModels23Map;